import { cn } from '../utilities.ts'

const LoaderVariants = {
  size: {
    sm: 'sm-solid-spinner',
  },
} as const

export type CircleLoaderProps = {
  size?: keyof typeof LoaderVariants.size
  className?: string
}

export function CircleLoader({ size = 'sm', className }: CircleLoaderProps) {
  return (
    <div
      className={cn(LoaderVariants.size[size], 'animate-spin', className)}
    ></div>
  )
}
